module.exports = __webpack_public_path__ + "static/media/purityx-1.9a1a8fec.png";